<app-navbar-control></app-navbar-control>

<div class="home-details">

    <app-hero></app-hero>
    <app-health-care-challenges></app-health-care-challenges>
    <app-health-care-workflow></app-health-care-workflow>
    <app-contact-section></app-contact-section>
    <app-footer></app-footer>
</div>